import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { List, X } from '@phosphor-icons/react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8ddecf7f-a4c9-427e-b02f-3053db4df717/artifacts/217o5tly_Marema_Logo.jpg";

const PublicHeader = ({ transparent = false }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const headerClass = transparent
    ? "absolute top-0 left-0 right-0 z-50"
    : "sticky top-0 z-50 bg-[#1a2332] shadow-md";

  const textClass = "text-white hover:text-[#4CAF50] font-medium transition-colors";

  return (
    <header className={headerClass} data-testid="public-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <img src={LOGO_URL} alt="Marema Consulting" className="h-[4.5rem] w-auto" />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link to="/" className={textClass}>Home</Link>
            <a href={transparent ? "#services" : "/#services"} className={textClass}>Services</a>
            <a href={transparent ? "#about" : "/#about"} className={textClass}>About</a>
            <Link to="/contact" className={textClass} data-testid="nav-contact-link">Contact</Link>
          </nav>

          <div className="hidden md:flex items-center gap-4">
            <Link to="/portal/login" className={textClass} data-testid="nav-client-login">
              Log Query Here
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <List className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-[#1a2332] border-t border-white/10 pb-4" data-testid="mobile-menu">
            <nav className="flex flex-col gap-3 pt-4 px-2">
              <Link to="/" className="text-white hover:text-[#4CAF50] py-2" onClick={() => setMobileMenuOpen(false)}>Home</Link>
              <a href={transparent ? "#services" : "/#services"} className="text-white hover:text-[#4CAF50] py-2" onClick={() => setMobileMenuOpen(false)}>Services</a>
              <a href={transparent ? "#about" : "/#about"} className="text-white hover:text-[#4CAF50] py-2" onClick={() => setMobileMenuOpen(false)}>About</a>
              <Link to="/contact" className="text-white hover:text-[#4CAF50] py-2" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
              <Link to="/portal/login" className="text-white hover:text-[#4CAF50] py-2" onClick={() => setMobileMenuOpen(false)}>Log Query Here</Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default PublicHeader;
